import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  InputGroup,
  Input,
  InputRightElement,
  SimpleGrid,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { SlMagnifier } from "react-icons/sl";
import { Classic } from "@/types/content";
import { useLazyGetClassicsQuery } from "@/services/api/endpoints/content";
import Consume1 from "@/assets/images/integral_img4.png";
import { Model } from "@/types/design";
import { BigModeImages } from "./base_modal_images";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectMode } from "@/reducer/modeslice";
import BaseModeItem from "./basemodeItem";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  changeBaseMode: (mode: Model) => void;
};
const TrainingBaseModesModal = (props: Props) => {
  const { isOpen, onClose, changeBaseMode } = props;

  const dispatch = useAppDispatch();
  const { design } = useAppSelector(selectMode);

  // const [classic, setClassic] = useState<Classic[]>([]);
  
  const classic = ["建筑设计", "室内设计"];
  // const [currentClassIndex, setCurrentClassIndex] = useState(0);
  const [currentClass, setCurrentClass] = useState("建筑设计");

  const modes = BigModeImages.filter(
      (image) => image.category === currentClass
    )
  const [currentModeIndex, setCurrentModeIndex] = useState(0);
  const [currentMode, setCurrentMode] = useState<Model>(design.bigmodel);
  const [searchValue, setSearchValue] = useState("");

  // const [getClassics] = useLazyGetClassicsQuery();

  // const getClassicsFun = async () => {
  //   let res = await getClassics({});
  //   if (res.data) {
  //     const all: Classic = { classic_name: "全部", id: "0", classic_order: 0 };
  //     const result = [all, ...res.data];
  //     setClassic(result);
  //   }
  // };
  useEffect(() => {
    if (isOpen) {
      // getClassicsFun();
      setCurrentMode(design.bigmodel);
      if(design.generatetype){
        setCurrentClass(design.generatetype)
      }else{
        setCurrentClass("建筑设计")
      }
      
    }
  }, [isOpen]);

  const handleChangeSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handChangeClassic = (item:string) => {
    setCurrentClass(item)
  };

  const handleChangeLargeMode = (mode: Model, index: number) => {
    // setCurrentModeIndex(index);
    setCurrentMode(mode)
    changeBaseMode(mode);
  };

  return (
    <>
      <Modal size={"6xl"} isOpen={isOpen} onClose={onClose} scrollBehavior={"inside"}>
        <ModalOverlay />
        <ModalContent bg="#0C0B10">
          <ModalHeader color="#FFFFFF" fontSize={"18px"}>
            选择模型
          </ModalHeader>
          <ModalCloseButton color={"#B9B9B9"} />
          <ModalBody pb={6}>
            <Flex justifyContent={"space-between"}>
              <Flex alignItems={"center"} gap="22px">
                {classic.map((item, index) => (
                  <Box
                    key={index}
                    color={currentClass === item ? "#27314D" : "#8E94A9"}
                    bg={currentClass === item ? "#DCE0EB" : "none"}
                    fontSize="12px"
                    p="2px 6px"
                    cursor={"pointer"}
                    onClick={() => handChangeClassic(item)}
                  >
                    {item}
                  </Box>
                ))}
              </Flex>

              <InputGroup w="336px">
                <Input
                  h="34px"
                  // w="400px"
                  boxSizing="border-box"
                  border="1px solid #8E94A9"
                  borderRadius={0}
                  bg="none"
                  color={"#8E94A9"}
                  fontSize="12px"
                  placeholder="请输入"
                  size="md"
                  value={searchValue}
                  onChange={handleChangeSearchValue}
                />
                <InputRightElement>
                  <SlMagnifier color="#8E94A9" />
                </InputRightElement>
              </InputGroup>
            </Flex>
            <Box mt="22px">
              <SimpleGrid columns={4} spacing={"20px"}>
                {modes &&
                  modes.map((item, index) => (
                    <Box
                      key={item.name}
                      border={
                        item.name === currentMode?.name
                          ? "3px solid #496AE1"
                          : "none"
                      }
                      boxSizing="border-box"
                      cursor="pointer"
                      onClick={() => handleChangeLargeMode(item, index)}
                    >
                      <BaseModeItem mode={item} />
                    </Box>
                  ))}
              </SimpleGrid>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default TrainingBaseModesModal;
